import React from 'react';

const Cheakout = () => {
    return (
        <div>
            <h4>this is Cheakout page</h4>
        </div>
    );
};

export default Cheakout;